import { createContext, type FC, type ReactNode, useCallback, useContext, useState } from 'react';

const AnnounceContext = createContext<(message: string) => void>(() => {});

/**
 * AnnouncerProvider - one polite live region for the app (optimistic rollbacks, async results).
 */
export const AnnouncerProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [message, setMessage] = useState('');
  const announce = useCallback((next: string) => {
    // Clear first so repeating the same message is announced again
    setMessage('');
    requestAnimationFrame(() => setMessage(next));
  }, []);
  return (
    <AnnounceContext.Provider value={announce}>
      {children}
      <div role="status" aria-live="polite" className="sr-only">{message}</div>
    </AnnounceContext.Provider>
  );
};

export const useAnnounce = (): ((message: string) => void) => useContext(AnnounceContext);
